var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChurch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4304 35H9.37408V12.1877L15.902 4.88635L22.4304 12.1877V35Z",
    fill: "#EDE6DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73046 35H0.909546V22.1813L9.73046 18.6736V35Z",
    fill: "#EDE6DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3016 35H31.123V22.1813L22.3016 18.6736V35Z",
    fill: "#EDE6DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.0008 35V25.8331C19.0008 24.7635 17.6084 23.8962 15.8911 23.8962C14.1734 23.8962 12.7815 24.7635 12.7815 25.8331V35H19.0008Z",
    fill: "#4C4640"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M4.94025 24.4226H4.65642C3.81974 24.4226 3.14191 24.9203 3.14191 25.5339V31.6806H6.45524V25.5339C6.45524 24.92 5.77693 24.4226 4.94025 24.4226Z",
    fill: "#4C4640"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.1481 24.4226H26.8642C26.0276 24.4226 25.3497 24.9203 25.3497 25.5339V31.6806H28.6631V25.5339C28.6626 24.92 27.9843 24.4226 27.1481 24.4226Z",
    fill: "#4C4640"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.0298 12.0698H15.7746C15.0629 12.0698 14.4862 12.493 14.4862 13.0152V17.0514C14.4862 17.1396 14.5835 17.211 14.7037 17.211H17.1002C17.2204 17.211 17.3178 17.1396 17.3178 17.0514V13.0152C17.3182 12.493 16.741 12.0698 16.0298 12.0698Z",
    fill: "#4C4640"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79868 24.7684C4.09318 24.7684 3.52124 25.1881 3.52124 25.7057V31.4643H6.0766V25.7057C6.07612 25.1881 5.50418 24.7684 4.79868 24.7684Z",
    fill: "#0081AF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9021 12.3278C15.3197 12.3278 14.8475 12.6743 14.8475 13.1016V16.8221C14.8475 16.8942 14.9271 16.9527 15.0254 16.9527H16.7789C16.8772 16.9527 16.9573 16.8942 16.9573 16.8221V13.1016C16.9573 12.6743 16.4851 12.3278 15.9021 12.3278Z",
    fill: "#0081AF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0059 24.7684C26.3004 24.7684 25.7285 25.1881 25.7285 25.7057V31.4643H28.2838V25.7057C28.2833 25.1881 27.7114 24.7684 27.0059 24.7684Z",
    fill: "#0081AF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3968 35.0001V26.3372C18.3968 25.3264 17.2801 24.5067 15.902 24.5067C14.5244 24.5067 13.4072 25.3261 13.4072 26.3372V35.0001H18.3968Z",
    fill: "#0081AF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.60138 18.6736V19.1226L0.909546 22.1813V22.7084L8.60138 19.7404V35H9.37414V18.6736H8.60138Z",
    fill: "#4C4640"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.2197 18.6736V19.1226L31.1191 22.1813V22.7084L23.2197 19.7404V35H22.4265V18.6736H23.2197Z",
    fill: "#4C4640"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0.696758 22.3106L9.86876 18.7718C10.1011 18.6822 10.1903 18.4711 10.0682 18.3007C9.94604 18.1302 9.6584 18.0648 9.42609 18.1544L0.254091 21.6932C0.0217854 21.7828 -0.0674171 21.9939 0.0546982 22.1643C0.176813 22.3348 0.464453 22.4002 0.696758 22.3106Z",
    fill: "#E96666"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3707 22.3106L22.1987 18.7718C21.9664 18.6822 21.8772 18.4711 21.9993 18.3007C22.1214 18.1302 22.409 18.0648 22.6413 18.1544L31.8133 21.6932C32.0456 21.7828 32.1348 21.9939 32.0127 22.1643C31.8906 22.3348 31.603 22.4002 31.3707 22.3106Z",
    fill: "#E96666"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6433 12.2546L16.2725 4.07789C16.1275 3.91724 15.8914 3.88189 15.6724 3.98829C15.6724 3.98829 15.608 4.00019 15.3423 4.27389L8.14804 12.2546C8.00302 12.4152 8.06313 12.6315 8.28208 12.7379C8.50103 12.8443 8.79582 12.8002 8.94083 12.6396L15.8957 4.92454L22.8505 12.6396C22.9955 12.8002 23.2903 12.8443 23.5093 12.7379C23.7282 12.6315 23.7883 12.4152 23.6433 12.2546Z",
    fill: "#E96666"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M9.37408 12.1877V12.9146L15.8958 5.6798L22.4304 12.9286V12.1877L15.902 4.88635L9.37408 12.1877Z",
    fill: "#4C4640"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.902 4.5906C15.7394 4.5906 15.6077 4.494 15.6077 4.37465V0.21595C15.6077 0.0965999 15.7394 0 15.902 0C16.0647 0 16.1964 0.0965999 16.1964 0.21595V4.375C16.1964 4.494 16.0647 4.5906 15.902 4.5906Z",
    fill: "#E96666"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8248 1.83998H13.9796C13.817 1.83998 13.6853 1.74338 13.6853 1.62403C13.6853 1.50468 13.817 1.40808 13.9796 1.40808H17.8248C17.9875 1.40808 18.1191 1.50468 18.1191 1.62403C18.1187 1.74303 17.987 1.83998 17.8248 1.83998Z",
    fill: "#E96666"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch);
export default __webpack_public_path__ + "static/media/church.7548c58254c88792e79c6bb1805047ca.svg";
export { ForwardRef as ReactComponent };